import {IComponentOptions} from 'angular';

declare let require: any;
declare let angular: any;
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IQService = angular.IQService;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;

require('./dv-checklist.scss');

export class DVChecklistComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        checklistPoints: '=',
        onCheckstatusChaged: '&',
        allChecked: '=?' // optional kann das 'model' auch ausserhalb der component gemapped werden
    };
    template = require('./dv-checklist.html');
    controller = DVChecklistController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DVChecklistController {
    static $inject = ['$log', '$translate', '$q', '$scope'];

    parentid: string;
    parentForm: IFormController;
    checklistForm: IFormController;
    checklistPoints = [];
    allChecked: boolean = false;

    onCheckstatusChaged: (paramObj: any) => void;

    /* @ngInject */
    constructor(private $log: ILogService, private $translate: ITranslateService,
                private $q: IQService,
                private $scope: IScope) {
    }

    $onInit() {
        if (this.checklistPoints === undefined) {
            this.$log.warn('no checkpoints defined, use checklist-points to pass checkpoints')
        }
    }

    private checkmarkSet() {
        if (this.onCheckstatusChaged) {
            this.onCheckstatusChaged({allchecked: this.allChecked});
        }
    }

    private getName(index: number): string {
        return 'check' + index;
    }

}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-checklist/dv-checklist.ts